// src/components/client-portal/Lockup.jsx
// Logo + brokerage line, the mark that opens every solo screen and closes the footer (mockup .lockup).
// width and height are set so the page never jumps while the PNG loads.
import { LOGO_WHITE_900 } from "./portalAssets";

export default function Lockup({ logo = LOGO_WHITE_900, alt = "Team Edelstein Real Estate" }) {
  return (
    <div className="lockup">
      <img src={logo.src} alt={alt} width={logo.width} height={logo.height} />
      <div className="cb">Coldwell Banker Realty</div>
    </div>
  );
}
